"use client";

import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { Band, SectionHead } from "../ui/Section";
import Reveal from "../ui/Reveal";
import Icon from "../ui/Icon";

const About = () => {
  const { t } = useLanguage();

  const channels = [
    {
      icon: "mail",
      label: t.about.emailLabel,
      value: t.about.email,
      href: `mailto:${t.about.email}`,
    },
    {
      icon: "whatsapp",
      label: t.about.whatsappLabel,
      value: t.about.whatsapp,
      href: `https://wa.me/${t.about.whatsapp.replace(/[^\d]/g, "")}`,
      external: true,
    },
  ];

  return (
    <Band id="about">
      <SectionHead index={6} label={t.about.eyebrow} title={t.about.title}>
        {t.about.description}
      </SectionHead>

      <div className="rail">
        <div className="rail__label" aria-hidden="true" />

        <div className="grid gap-12 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-7">
            <ul className="divide-rule border-y border-line">
              {channels.map((channel) => (
                <Reveal as="li" key={channel.label}>
                  <a
                    href={channel.href}
                    target={channel.external ? "_blank" : undefined}
                    rel={channel.external ? "noopener noreferrer" : undefined}
                    className="group flex items-center gap-4 py-5"
                  >
                    <Icon name={channel.icon} size={19} className="flex-none text-ink-3" />
                    <span className="min-w-0">
                      <span className="eyebrow block">{channel.label}</span>
                      <span className="mt-1 block truncate text-[16px] font-medium">
                        {channel.value}
                      </span>
                    </span>
                    <Icon
                      name="arrowUpRight"
                      size={17}
                      className="ml-auto flex-none text-ink-3 transition-transform duration-200 ease-out group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-ink"
                    />
                  </a>
                </Reveal>
              ))}
            </ul>

            <Reveal delay={0.08}>
              <p className="meta mt-5">{t.about.responseTime}</p>
            </Reveal>
          </div>

          <Reveal delay={0.06} className="lg:col-span-5">
            <div className="panel flex h-full flex-col justify-between gap-8 p-7 md:p-8">
              <div>
                <span className="eyebrow">{t.footer.fromHyphenTech}</span>
                <p className="title-sm mt-4">Hyphen Tech</p>
                <p className="meta mt-3">{t.footer.address}</p>
              </div>
              <a
                href="https://hyphentech.africa"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn--secondary self-start"
              >
                {t.about.visitHyphenTech}
                <Icon name="arrowUpRight" size={15} />
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </Band>
  );
};

export default About;
